import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Flex, Loader } from '@mantine/core';

export const WithAuth = ({ children }: { children: JSX.Element }) => {
  let auth = useAuth();
  let location = useLocation();

  if (!auth || auth?.validating) {
    // If we're validating the user's session, show a loading spinner
    return (
      <Flex align="center" justify="center" mih={300} w="100%">
        <Loader />
      </Flex>
    );
  }

  if (!auth?.user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
